import { FC } from 'react'
import imageResize from 'project/image-proxy-web' // we need this to make JSX compile

type ImagesType = {
  props: {
    className: string
    alt: string
    width?: string
    height?: string
    src: string
  }
}

type VisionImagesType = {
  images: ImagesType['props'][]
}

const VisionImages: FC<VisionImagesType> = ({ images }) => {
  return (
    <>
      {images.map((image) => {
        return (
          <img
            loading='lazy'
            src={imageResize(image.src)}
            alt={image.alt}
            className={image.className}
            style={{
              height: image.height ? image.height : 'auto',
              width: image.width,
            }}
          />
        )
      })}
    </>
  )
}

export default VisionImages
